var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKonfiguracijaZakljucavanja(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "30px",
    width: "30px",
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,17c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C17,17.4,16.6,17,16,17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,10c-1.7,0-3,1.3-3,3v1h6v-1C19,11.3,17.7,10,16,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5,12.3c-0.1-0.5-0.6-0.8-1.1-0.8c-1.5,0.2-2.9-0.5-3.6-1.8c-0.7-1.3-0.6-2.8,0.3-4c0.3-0.4,0.3-1-0.1-1.3 c-1.8-1.7-4.1-3-6.5-3.7c-0.5-0.1-1,0.1-1.2,0.6c-0.6,1.4-1.9,2.2-3.3,2.2s-2.8-0.9-3.3-2.2c-0.2-0.5-0.7-0.7-1.2-0.6 C9.1,1.4,6.8,2.7,5,4.4C4.6,4.8,4.6,5.3,4.9,5.7c0.9,1.2,1,2.7,0.3,4c-0.7,1.3-2.1,2-3.6,1.8c-0.5-0.1-1,0.3-1.1,0.8 C0.2,13.5,0,14.8,0,16s0.2,2.5,0.5,3.7c0.1,0.5,0.6,0.8,1.1,0.8C3,20.3,4.4,21,5.1,22.3c0.7,1.3,0.6,2.8-0.3,4 c-0.3,0.4-0.3,1,0.1,1.3c1.8,1.7,4.1,3,6.5,3.7c0.5,0.1,1-0.1,1.2-0.6c0.6-1.4,1.9-2.2,3.3-2.2s2.8,0.9,3.3,2.2 c0.2,0.4,0.5,0.6,0.9,0.6c0.1,0,0.2,0,0.3,0c2.4-0.7,4.6-2,6.5-3.7c0.4-0.4,0.4-0.9,0.1-1.3c-0.9-1.2-1-2.7-0.3-4 c0.7-1.3,2.1-2,3.6-1.8c0.5,0.1,1-0.3,1.1-0.8c0.3-1.3,0.5-2.5,0.5-3.7S31.8,13.5,31.5,12.3z M22,21c0,1.7-1.3,3-3,3h-6 c-1.7,0-3-1.3-3-3v-4c0-0.9,0.4-1.7,1-2.2V13c0-2.8,2.2-5,5-5s5,2.2,5,5v1.8c0.6,0.5,1,1.3,1,2.2V21z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKonfiguracijaZakljucavanja);
export default __webpack_public_path__ + "static/media/KonfiguracijaZakljucavanja.20990ce5e0abbd8e6ea33135500c0df2.svg";
export { ForwardRef as ReactComponent };